import Swiper, {Autoplay, Navigation, Scrollbar} from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

window.boxesProductsSliderInit = function boxesProductsSliderInit() {
  let boxesProductsSwiperWr = document.querySelectorAll('.boxes-products-swiper-wr');
  boxesProductsSwiperWr.forEach((el) => {
    if (el) {
      let swiperEl = el.querySelector('.swiper');
      let nextEl = el.querySelector('.swiper-button-next');
      let prevEl = el.querySelector('.swiper-button-prev');
      let scrollbarEl = el.querySelector('.swiper-scrollbar');
      let slidesCount = el.querySelectorAll('.swiper-slide').length;
      let wrapper = swiperEl.querySelector('.swiper-wrapper');
      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation, Scrollbar],
        observer: true,
        observeParents: true,
        spaceBetween: 12,
        slidesPerView: 1.25,
        threshold: 10,
        allowTouchMove: window.innerWidth <= 1024,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
          snapOnRelease: true,
        },
        breakpoints: {
          451: {
            spaceBetween: 16,
            slidesPerView: 1,
          },
          1101: {
            spaceBetween: 16,
            slidesPerView: 2,
          },
        },
        autoplay: {
          delay: 400000,
          disableOnInteraction: false,
          pauseOnMouseEnter: window.innerWidth > 1024,
        },
      });
      swiperObserver(swiper);

      swiperEl.addEventListener('wheel', (e) => {
        if (!e.shiftKey) return;

        e.preventDefault();

        if (e.deltaY > 0) {
          swiper.slideNext();
        } else {
          swiper.slidePrev();
        }
      }, { passive: false });
    }
  });
}